/**
 * ============================================================================
 * TaskFlow ERP
 * Module : Campaign Management
 * Feature: Import Workspace
 *
 * File:
 * src/modules/campaign/prospectImport/components/importWorkspace/ImportWorkspace.jsx
 *
 * Description:
 * Generic ERP Import Workspace.
 *
 * Temporary Version
 * -----------------
 * Only UploadPanel is enabled.
 * Remaining stages will be enabled as they are developed.
 * ============================================================================
 */

import React from "react";

import {
    Container,
    Row,
    Col
} from "react-bootstrap";

import UploadPanel from "./upload/UploadPanel";

import ValidationDashboard from "./validation/ValidationDashboard";

import ReviewGrid from "./review/ReviewGrid";
import ViewDrawer from "./drawers/ViewDrawer";
import EditDrawer from "./drawers/EditDrawer";
import CompareDrawer from "./drawers/CompareDrawer";

export default function ImportWorkspace({

    config,

    state,

    actions,

    readOnly = false

}) {
    // ======================================================
    // STATE
    // ======================================================

    const {

        verified = false

    } = state;

    return (

        <Container fluid>

            {/* ====================================================== */}
            {/* UPLOAD STAGE */}
            {/* ====================================================== */}

            <Row>

                <Col>

                    <UploadPanel

                        config={config}

                        state={state}

                        actions={actions}

                        readOnly={readOnly}

                    />

                </Col>

            </Row>

            {/* ====================================================== */}
            {/* VALIDATION STAGE */}
            {/* ====================================================== */}

            {verified && (

                <Row className="mt-4">

                    <Col>

                        <ValidationDashboard

                            config={config}

                            state={state}

                            actions={actions}

                        />

                    </Col>

                </Row>

            )}

            {/* ====================================================== */}
            {/* REVIEW STAGE */}
            {/* ====================================================== */}

            {verified && (

                <Row className="mt-4">

                    <Col>

                        <ReviewGrid

                            config={config}

                            state={state}

                            actions={actions}

                        />

                    </Col>

                </Row>

            )}

            {/* ====================================================== */}
            {/* IMPORT PROGRESS */}
            {/* Will be enabled after ImportProgressDialog.jsx is created */}
            {/* ====================================================== */}

            {/* <ImportProgressDialog /> */}

            {/* ====================================================== */}
            {/* DRAWERS */}
            {/* Will be enabled after drawer components are created */}
            {/* ====================================================== */}

            {/* <CompareDrawer /> */}

            {/* <EditDrawer /> */}

            {/* ====================================================== */}
            {/* VIEW DRAWER */}
            {/* ====================================================== */}

            <ViewDrawer

                show={state.showViewDrawer}

                config={config}

                state={state}

                actions={actions}

            />
            {/* ====================================================== */}
            {/* EDIT DRAWER */}
            {/* ====================================================== */}

            <EditDrawer

                show={state.showEditDrawer}

                config={config}

                state={state}

                actions={actions}

            />
            {/* ====================================================== */}
            {/* COMPARE DRAWER */}
            {/* ====================================================== */}

            <CompareDrawer

                show={state.showCompareDrawer}

                config={config}

                state={state}

                actions={actions}

            />

        </Container>

    );

}